// extracted by mini-css-extract-plugin
export default {"certificate-icon":"cyurAgE0k_HL0aNDp0rO","icon":"ffwjExFXBY2qrYLivX5K"};